module.exports = __webpack_public_path__ + "static/media/AE.4e38927b.png";